/* Odyssey site translation (Nov 2 2026).
   Shopify publishes the languages (/fr, /de, ...). Most of this theme's text is hard-coded English in custom
   sections, so this script swaps every visible string for the current language from a dictionary
   (assets/i18n-<lang>.js, built by Desktop/odyssey-claude-export/i18n). Text that is not in the dictionary yet
   (a new section, a price line) is translated on the fly by the checkout server and remembered, so a site
   edit shows up translated without anyone touching this.
   Also: first-visit language pick from browser language + country, the Canada EN/FR tab, the language bar
   for other countries, the footer language picker, /lang prefix on internal links and the checkout. */
(function () {
  var C = window.OdyI18n;
  if (!C || window.__odyI18nRan) return;
  window.__odyI18nRan = true;

  var LANG = C.lang, PRIMARY = C.primaryLang || 'en', ROOT = C.root || '/';
  var isPrimary = LANG === PRIMARY;
  var published = (C.locales || []).map(function (l) { return l.iso; });
  var API = 'https://checkout.odysseyproductsshop.com/api/i18n';
  var BOT = /bot|crawl|spider|slurp|google|bing|yandex|baidu|duckduck|facebookexternalhit|lighthouse|headless|preview/i.test(navigator.userAgent);

  // ---------- cookies ----------
  function getCookie(n) { var m = document.cookie.match('(?:^|; )' + n + '=([^;]*)'); return m ? decodeURIComponent(m[1]) : '' }
  function setCookie(n, v) {
    var base = '; path=/; max-age=31536000; SameSite=Lax';
    document.cookie = n + '=' + encodeURIComponent(v) + base + (/odysseyproductsshop\.com$/.test(location.hostname) ? '; domain=.odysseyproductsshop.com' : '');
  }

  // ---------- language choice ----------
  // Languages spoken per country (first = default). Countries with 2+ get the language bar.
  var COUNTRY_LANGS = {
    CA: ['en', 'fr'], US: ['en'], GB: ['en'], IE: ['en'], AU: ['en'], NZ: ['en'],
    FR: ['fr'], MC: ['fr'], BE: ['nl', 'fr', 'de'], CH: ['de', 'fr', 'it'], LU: ['fr', 'de'],
    DE: ['de'], AT: ['de'], LI: ['de'], IT: ['it'], SM: ['it'], ES: ['es'], MX: ['es'], AR: ['es'], CO: ['es'],
    CL: ['es'], PE: ['es'], VE: ['es'], EC: ['es'], GT: ['es'], CR: ['es'], PA: ['es'], UY: ['es'], PY: ['es'],
    BO: ['es'], DO: ['es'], PR: ['es', 'en'], BR: ['pt-BR'], PT: ['pt-BR'], NL: ['nl'], SE: ['sv'], FI: ['fi', 'sv'],
    NO: ['nb'], DK: ['da'], PL: ['pl'], RU: ['ru'], BY: ['ru'], KZ: ['ru'], UA: ['ru', 'en'], LV: ['en', 'ru'],
    EE: ['en', 'ru'], LT: ['en'], JP: ['ja'], KR: ['ko'], CN: ['zh-CN'], SG: ['en', 'zh-CN'], MY: ['en', 'zh-CN'],
    TW: ['zh-TW'], HK: ['zh-TW', 'en'], MO: ['zh-TW'], TR: ['tr'], VN: ['vi'], ID: ['id'], SN: ['fr'], CI: ['fr'],
    MA: ['fr'], DZ: ['fr'], TN: ['fr'], HT: ['fr'], CM: ['fr', 'en']
  };
  function norm(code) {
    if (!code) return '';
    code = code.toLowerCase();
    if (code === 'zh-tw' || code === 'zh-hk' || code === 'zh-hant' || code === 'zh-mo') return 'zh-TW';
    if (code.indexOf('zh') === 0) return 'zh-CN';
    if (code.indexOf('pt') === 0) return 'pt-BR';
    if (code === 'no' || code === 'nn' || code.indexOf('nb') === 0 || code.indexOf('no-') === 0) return 'nb';
    return code.split('-')[0];
  }
  function ok(l) { return published.indexOf(l) > -1 }
  function preferred() {
    var nav = (navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || '']).map(norm);
    var first = '';
    for (var i = 0; i < nav.length; i++) if (ok(nav[i])) { first = nav[i]; break }
    var cl = (COUNTRY_LANGS[C.country] || []).filter(ok);
    if (first && first !== PRIMARY) return first;              // browser asks for a language we have
    // Browser English first, but also speaks the country's main language (a Swiss visitor with en,de -> de).
    // Not where English is a main language (an English-first Canadian stays English and has the EN/FR tab).
    if (cl.length && cl[0] !== PRIMARY)
      for (var j = 0; j < cl.length; j++)
        if (cl[j] !== PRIMARY && nav.indexOf(cl[j]) > -1) return cl[j];
    if (!first && cl.length && cl[0] !== PRIMARY) return cl[0]; // browser language we don't have: use the country's
    return first || PRIMARY;
  }
  // Path without the current language prefix (Shopify's own root: /fr, /pt, /zh-hans, ...).
  function pathFor() {
    var p = location.pathname, r = ROOT.replace(/\/$/, '');
    if (r && (p === r || p.toLowerCase().indexOf(r.toLowerCase() + '/') === 0)) p = p.slice(r.length) || '/';
    return p + location.search.replace(/([?&])lang_auto=0&?/, '$1') + location.hash;
  }
  // Shopify redirects by browser language on its own (an English browser opening /fr/... is sent back to
  // English), so a choice must go through Shopify's localization form: that makes it stick for Shopify too.
  function go(lang, manual) {
    if (manual) setCookie('ody_lang_set', '1');
    setCookie('ody_lang', lang);
    if (lang === LANG) return;
    var back = pathFor();
    var f = document.createElement('form');
    f.method = 'post'; f.action = ROOT.replace(/\/$/, '') + '/localization'; f.style.display = 'none';
    var fields = { form_type: 'localization', utf8: '\u2713', _method: 'put', locale_code: lang, return_to: back };
    for (var k in fields) { var i = document.createElement('input'); i.type = 'hidden'; i.name = k; i.value = fields[k]; f.appendChild(i) }
    (document.body || document.documentElement).appendChild(f);
    f.submit();
  }
  window.odySetLanguage = function (l) { go(l, true) };

  // First visit: send the visitor to their language once. A manual choice always wins afterwards.
  if (!BOT && !getCookie('ody_lang_set')) {
    var remembered = getCookie('ody_lang');
    var want = remembered && ok(remembered) ? remembered : preferred();
    if (!remembered && isPrimary && want !== LANG && !/[?&](lang_auto=0|preview_theme_id)/.test(location.search)) {
      document.documentElement.style.opacity = '0';
      setTimeout(function () { document.documentElement.style.opacity = '' }, 4000);
      go(want, false);
      return;
    }
    if (!remembered) setCookie('ody_lang', LANG);
  }
  if (!getCookie('ody_lang') || getCookie('ody_lang') !== LANG) setCookie('ody_lang', LANG);

  // ---------- translation ----------
  var dict = null, patterns = null, cacheKey = 'odyI18n:' + LANG + ':v2', runtime = {};
  // Text this script already wrote is never translated again: a translation that is not itself a key (Vietnamese,
  // Indonesian: Latin letters) would otherwise go back to the live translator and swap forever (Nov 3 2026).
  var ours = {};
  function own(v) { ours[v.replace(/\s+/g, ' ').trim()] = 1 }
  try { runtime = JSON.parse(localStorage.getItem(cacheKey) || '{}') } catch (e) {}
  var NUM = /(?:[A-Z]{1,3})?[$£€¥₩]\s?\d[\d,.]*|\d[\d,.]*\s?(?:%|kg|lb|lbs|g|ml|oz)?/g;
  var LETTERS = /[A-Za-z]{2}/;
  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, CODE: 1, TEMPLATE: 1, TEXTAREA: 1, SVG: 1 };
  var ATTRS = ['placeholder', 'alt', 'aria-label', 'title'];
  var done = new WeakMap(), misses = {}, missTimer = 0;

  function buildPatterns() {
    patterns = {};
    for (var o in dict) if (dict[o] !== o) own(dict[o]);
    for (var r in runtime) if (runtime[r] !== r) own(runtime[r]);
    for (var k in dict) {
      var nums = k.match(NUM);
      if (!nums || !nums.length) continue;
      var pk = k.replace(NUM, '\u0001'), v = dict[k], okv = true;
      var pv = v;
      for (var i = 0; i < nums.length; i++) {
        var at = pv.indexOf(nums[i]);
        if (at < 0) { okv = false; break }
        pv = pv.slice(0, at) + '\u0002' + i + '\u0003' + pv.slice(at + nums[i].length);
      }
      if (okv && !patterns[pk]) patterns[pk] = pv;
    }
  }
  function lookup(s) {
    if (ours[s]) return null;
    if (dict && dict[s] != null) return dict[s];
    if (runtime[s] != null) return runtime[s];
    var nums = s.match(NUM);
    if (nums && patterns) {
      var p = patterns[s.replace(NUM, '\u0001')];
      if (p != null) return p.replace(/\u0002(\d+)\u0003/g, function (_, i) { return nums[+i] });
    }
    return null;
  }
  function translateText(raw, onMiss) {
    var t = raw.replace(/\s+/g, ' ').trim();
    if (!t || !LETTERS.test(t) || ours[t]) return null;
    var v = lookup(t);
    if (v == null) { if (onMiss) onMiss(t); return null }
    if (v === t) return null;
    own(v);
    var lead = raw.match(/^\s*/)[0], trail = raw.match(/\s*$/)[0];
    return lead + v + trail;
  }
  function skipEl(el) {
    for (var e = el; e && e !== document.documentElement; e = e.parentElement) {
      if (SKIP_TAGS[e.tagName] || SKIP_TAGS[e.tagName && e.tagName.toUpperCase()]) return true;
      if (e.hasAttribute && (e.hasAttribute('data-no-i18n') || e.getAttribute('translate') === 'no' || e.isContentEditable)) return true;
    }
    return false;
  }
  function addMiss(t) {
    if (t.length > 4000 || /^[\w.+-]+@[\w.-]+$/.test(t)) return;
    misses[t] = 1;
    clearTimeout(missTimer); missTimer = setTimeout(flushMisses, 600);
  }
  function doText(n) {
    if (done.get(n) === n.nodeValue) return;
    var par = n.parentElement; if (!par || skipEl(par)) return;
    var r = translateText(n.nodeValue, addMiss);
    if (r != null) n.nodeValue = r;
    done.set(n, n.nodeValue);
  }
  function doAttrs(el) {
    for (var i = 0; i < ATTRS.length; i++) {
      var a = el.getAttribute(ATTRS[i]); if (!a) continue;
      var r = translateText(a, addMiss); if (r != null) el.setAttribute(ATTRS[i], r);
    }
    if (el.tagName === 'INPUT' && /^(submit|button)$/i.test(el.type) && el.value) {
      var rv = translateText(el.value, addMiss); if (rv != null) el.value = rv;
    }
  }
  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) { doText(root); return }
    if (root.nodeType !== 1 && root.nodeType !== 9 && root.nodeType !== 11) return;
    if (root.nodeType === 1) { if (skipEl(root)) return; doAttrs(root) }
    var tw = document.createTreeWalker(root, 5, null), n;
    while ((n = tw.nextNode())) {
      if (n.nodeType === 3) doText(n);
      else if (n.nodeType === 1) { if (SKIP_TAGS[n.tagName]) continue; if (n.hasAttribute('placeholder') || n.hasAttribute('alt') || n.hasAttribute('aria-label') || n.hasAttribute('title') || n.tagName === 'INPUT') doAttrs(n) }
    }
  }
  function doHead() {
    var t = translateText(document.title, addMiss); if (t != null) document.title = t;
    var md = document.querySelector('meta[name="description"]');
    if (md) { var d = translateText(md.content, null); if (d != null) md.content = d }
    var og = document.querySelector('meta[property="og:title"]');
    if (og) { var o = translateText(og.content, null); if (o != null) og.content = o }
  }
  function flushMisses() {
    var list = Object.keys(misses).filter(function (s) { return lookup(s) == null }).slice(0, 80);
    misses = {};
    if (!list.length || BOT) return;
    fetch(API + '/translate', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ lang: LANG, strings: list, path: location.pathname }) })
      .then(function (r) { return r.ok ? r.json() : null })
      .then(function (j) {
        if (!j || !j.translations) return;
        for (var k in j.translations) runtime[k] = j.translations[k];
        try { localStorage.setItem(cacheKey, JSON.stringify(runtime)) } catch (e) {}
        walk(document.body); doHead();
      }).catch(function () {});
  }

  // Internal links keep the language: /pages/x -> /fr/pages/x. The checkout gets ?lang=.
  var LOCAL = /^\/(?!cdn\/|apps\/|checkouts?\/|services\/|account\/logout|tools\/|a\/|\/)/;
  var prefix = ROOT.replace(/\/$/, '').toLowerCase();
  function fixLink(a) {
    var h = a.getAttribute('href'); if (!h) return;
    if (!isPrimary && prefix && LOCAL.test(h)) {
      var lh = h.toLowerCase();
      if (lh !== prefix && lh.indexOf(prefix + '/') !== 0 && lh.indexOf(prefix + '?') !== 0) a.setAttribute('href', prefix + h);
    }
    if (/^https:\/\/checkout\.odysseyproductsshop\.com/.test(h) && !/[?&]lang=/.test(h) && !isPrimary)
      a.setAttribute('href', h + (h.indexOf('?') > -1 ? '&' : '?') + 'lang=' + LANG);
  }
  function fixLinks(root) { if (root.querySelectorAll) { if (root.tagName === 'A') fixLink(root); var as = root.querySelectorAll('a[href]'); for (var i = 0; i < as.length; i++) fixLink(as[i]) } }

  // ---------- UI: language bar, Canada tab, footer picker ----------
  function nameOf(l) { for (var i = 0; i < C.locales.length; i++) if (C.locales[i].iso === l) return C.locales[i].name; return l }
  var CSS = '.ody-lang-hd{display:inline-flex;align-items:center;gap:2px;margin-right:6px;vertical-align:middle;font:600 13px/1 var(---font-stack-body,Archivo Narrow,Arial,sans-serif);letter-spacing:.04em;text-transform:uppercase}' +
    '.ody-lang-hd button{all:unset;cursor:pointer;padding:6px 5px;color:inherit;opacity:.45}' +
    '.ody-lang-hd button[aria-current=true]{opacity:1;text-decoration:underline;text-underline-offset:4px}' +
    '.ody-lang-hd .ody-lang-sep{opacity:.35}' +
    '.ody-lang-hd .ody-lang-globe{opacity:1;display:inline-flex;align-items:center;gap:4px}' +
    '.ody-lang-hd svg{width:18px;height:18px}' +
    '.mobile-menu .ody-lang-hd{margin-right:2px}' +
    '.ody-lang-menu{position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:16px}' +
    '.ody-lang-menu>div{background:#fff;color:#111;max-width:520px;width:100%;max-height:80vh;overflow:auto;padding:20px}' +
    '.ody-lang-menu h3{margin:0 0 12px;font-family:var(---font-stack-heading,Fjalla One,sans-serif);font-weight:400;text-transform:uppercase}' +
    '.ody-lang-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(140px,1fr));gap:6px}' +
    '.ody-lang-grid button{all:unset;cursor:pointer;padding:10px;border:1px solid #ddd;font:14px var(---font-stack-body,Arial,sans-serif)}' +
    '.ody-lang-grid button[aria-current=true]{border-color:#e20606;color:#e20606}' +
    '.ody-lang-pick{text-align:center;padding:14px 12px;font:13px var(---font-stack-body,Arial,sans-serif)}' +
    '.ody-lang-pick button{all:unset;cursor:pointer;padding:4px 10px;border:1px solid currentColor}';
  var GLOBE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3c2.5 2.6 3.8 5.6 3.8 9s-1.3 6.4-3.8 9c-2.5-2.6-3.8-5.6-3.8-9S9.5 5.6 12 3z"/></svg>';
  function menu() {
    var wrap = document.createElement('div'); wrap.className = 'ody-lang-menu';
    var box = '<div role="dialog" aria-label="Language"><h3>🌐 ' + (lookup('Language') || 'Language') + '</h3><div class="ody-lang-grid">';
    C.locales.forEach(function (l) { box += '<button type="button" translate="no" data-l="' + l.iso + '"' + (l.iso === LANG ? ' aria-current="true"' : '') + '>' + l.name + '</button>' });
    wrap.innerHTML = box + '</div></div>';
    wrap.addEventListener('click', function (e) { var b = e.target.closest('button[data-l]'); if (b) go(b.getAttribute('data-l'), true); else if (e.target === wrap) wrap.remove() });
    document.body.appendChild(wrap);
  }
  window.odyLanguageMenu = menu;
  // Header switcher beside the search icon (Yannick, Nov 2: no bar across the top). Canada gets a direct
  // EN | FR toggle; everyone else a globe + current language that opens the full list.
  function headerSwitch() {
    var el = document.createElement('span'); el.className = 'ody-lang-hd';
    if (C.country === 'CA' && ok('fr')) {
      el.innerHTML = '<button type="button" translate="no" data-l="en"' + (LANG === 'en' ? ' aria-current="true"' : '') + '>EN</button><span class="ody-lang-sep">|</span><button type="button" translate="no" data-l="fr"' + (LANG === 'fr' ? ' aria-current="true"' : '') + '>FR</button>';
      if (LANG !== 'en' && LANG !== 'fr') el.innerHTML += '<button type="button" class="ody-lang-globe" translate="no" data-more>' + LANG.toUpperCase() + '</button>';
    } else {
      el.innerHTML = '<button type="button" class="ody-lang-globe" translate="no" data-more aria-label="Language">' + GLOBE + LANG.split('-')[0].toUpperCase() + '</button>';
    }
    el.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      e.preventDefault();
      if (b.hasAttribute('data-more')) return menu();
      go(b.getAttribute('data-l'), true);
    });
    return el;
  }
  function ui() {
    if (document.getElementById('ody-lang-css')) return;
    var st = document.createElement('style'); st.id = 'ody-lang-css'; st.textContent = CSS; document.head.appendChild(st);
    var anchors = document.querySelectorAll('[data-nav-search-open], .mobile-menu .cart__toggle');
    for (var i = 0; i < anchors.length; i++) {
      var a = anchors[i];
      if (a.closest('.ody-lang-hd')) continue;
      a.parentNode.insertBefore(headerSwitch(), a);
    }
    var foot = document.querySelector('footer, .site-footer, [id*="footer"]');
    var pick = document.createElement('div'); pick.className = 'ody-lang-pick';
    pick.innerHTML = '<button type="button" translate="no">🌐 ' + nameOf(LANG) + ' ▾</button>';
    pick.firstChild.addEventListener('click', menu);
    (foot || document.body).appendChild(pick);
  }


  // ---------- images with text baked in: swapped for the language's version (theme assets i18n-<lang>-*) ----------
  var IMAGES = { fr: {"mat-hero-fullmat2.jpg":"i18n-fr-mat-hero-fullmat2.jpg","bench-mat-hero-no-chalk.jpg":"i18n-fr-mat-hero-fullmat2.jpg","mat-tc-bench-2-hd.jpg":"i18n-fr-mat-tc-bench-2-hd.jpg","mat-tc-bench-2.jpg":"i18n-fr-mat-tc-bench-2-hd.jpg","bench-mat-slide-stop-sliding.jpg":"i18n-fr-mat-tc-bench-2-hd.jpg","mat-tc-3-hd.jpg":"i18n-fr-mat-tc-3-hd.jpg","mat-tc-3.jpg":"i18n-fr-mat-tc-3-hd.jpg","mat-tc-bench-5b-hd.jpg":"i18n-fr-mat-tc-bench-5b-hd.jpg","mat-tc-bench-5b.jpg":"i18n-fr-mat-tc-bench-5b-hd.jpg","bench-mat-slide-grip-more.jpg":"i18n-fr-mat-tc-bench-5b-hd.jpg","mat-tc-bench-6-hd.jpg":"i18n-fr-mat-tc-bench-6-hd.jpg","mat-tc-bench-6.jpg":"i18n-fr-mat-tc-bench-6-hd.jpg","bench-mat-slide-routine.jpg":"i18n-fr-mat-tc-bench-6-hd.jpg","mat-tc-bench-7-hd.jpg":"i18n-fr-mat-tc-bench-7-hd.jpg","mat-tc-bench-7.jpg":"i18n-fr-mat-tc-bench-7-hd.jpg","bench-mat-slide-guarantee.jpg":"i18n-fr-mat-tc-bench-7-hd.jpg","leg-drive-diagram-hd.jpg":"i18n-fr-leg-drive-diagram-hd.jpg","leg-drive-diagram.jpg":"i18n-fr-leg-drive-diagram-hd.jpg","02-leg-drive-diagram-v3.png":"i18n-fr-leg-drive-diagram-hd.jpg","chalk-nl-1-hd.jpg":"i18n-fr-chalk-nl-1-hd.jpg","chalk-nl-1.jpg":"i18n-fr-chalk-nl-1-hd.jpg","chalk-nl-2-hd.jpg":"i18n-fr-chalk-nl-2-hd.jpg","chalk-nl-2.jpg":"i18n-fr-chalk-nl-2-hd.jpg","chalk-nl-4-hd.jpg":"i18n-fr-chalk-nl-4-hd.jpg","chalk-nl-4.jpg":"i18n-fr-chalk-nl-4-hd.jpg","chalk-nl-5-hd.jpg":"i18n-fr-chalk-nl-5-hd.jpg","chalk-nl-5.jpg":"i18n-fr-chalk-nl-5-hd.jpg","chalk-nl-6-hd.jpg":"i18n-fr-chalk-nl-6-hd.jpg","chalk-nl-6.jpg":"i18n-fr-chalk-nl-6-hd.jpg","chalk-v4-3-hd.jpg":"i18n-fr-chalk-v4-3-hd.jpg","chalk-v4-3.jpg":"i18n-fr-chalk-v4-3-hd.jpg","chalk-nl-7-hd.jpg":"i18n-fr-chalk-nl-7-hd.jpg","chalk-nl-7.jpg":"i18n-fr-chalk-nl-7-hd.jpg","chalk-two-caps-v2-hd.jpg":"i18n-fr-chalk-two-caps-v2-hd.jpg","chalk-two-caps-v2.jpg":"i18n-fr-chalk-two-caps-v2-hd.jpg","immortal-slide-1.jpg":"i18n-fr-immortal-slide-1.jpg","immortal-slide-2.jpg":"i18n-fr-immortal-slide-2.jpg","immortal-slide-3.jpg":"i18n-fr-immortal-slide-3.jpg","immortal-slide-4.jpg":"i18n-fr-immortal-slide-4.jpg","immortal-slide-5.jpg":"i18n-fr-immortal-slide-5.jpg","max-offer-cad.jpg":"i18n-fr-max-offer-cad.jpg","max-offer-intl.jpg":"i18n-fr-max-offer-intl.jpg","max-email-eca.jpg":"i18n-fr-max-email-eca.jpg","max-email-eint2.jpg":"i18n-fr-max-email-eint2.jpg","max-tc-1.jpg":"i18n-fr-max-tc-1.jpg","max-tc-2.jpg":"i18n-fr-max-tc-2.jpg","max-tc-5.jpg":"i18n-fr-max-tc-5.jpg","max-tc-6.jpg":"i18n-fr-max-tc-6.jpg","max-tc-7.jpg":"i18n-fr-max-tc-7.jpg","odyssey-gift-card-1.jpg":"i18n-fr-odyssey-gift-card-1.jpg","odyssey-gift-card-2.jpg":"i18n-fr-odyssey-gift-card-2.jpg","odyssey-gift-card-3.jpg":"i18n-fr-odyssey-gift-card-3.jpg"} };
  // Other languages (Nov 3 2026): the same 32 product images re-made per language and uploaded to Shopify Files as
  // i18n-<lang>-<English file name>.jpg (i18n/images/build-lang.sh, max/offer-lang.sh).
  var FILE_LANGS = ['es', 'de', 'it', 'pt-BR', 'nl', 'sv', 'nb', 'da', 'fi', 'pl', 'ru', 'ja', 'ko', 'zh-CN', 'zh-TW', 'tr', 'vi', 'id'];
  if (FILE_LANGS.indexOf(LANG) >= 0) {
    IMAGES[LANG] = {};
    for (var en in IMAGES.fr) { var b = IMAGES.fr[en].replace('i18n-fr-', ''); IMAGES[LANG][en] = 'i18n-' + LANG + '-' + b }
  }
  var IMG = IMAGES[LANG] || null, ASSETS = C.assetBase || '', IMG_ROOT = LANG === 'fr' ? ASSETS.replace(/^https?:/, '').replace(/^\/\/[^/]+/, '') : '/cdn/shop/files/';
  var IMG_RE = /\/cdn\/shop\/(?:t\/\d+\/assets|files)\/([^\/?#\s]+?)(?:_[0-9a-f]{8}-[0-9a-f-]{27})?(\.(?:jpe?g|png|webp))(\?[^\s,]*)?/gi;
  function swapUrl(u) {
    return u.replace(IMG_RE, function (all, base, ext, q) {
      var fr = IMG[base + ext] || IMG[base + '.jpg'] || IMG[base + '.png'];
      if (!fr) return all;
      var w = (q || '').match(/[?&]width=\d+/);
      return IMG_ROOT + fr + (w ? '?' + w[0].slice(1) : '');
    });
  }
  function swapImg(el) {
    if (!IMG || !IMG_ROOT) return;
    for (var k = 0, a = ['src', 'srcset', 'data-src', 'data-srcset']; k < a.length; k++) {
      var v = el.getAttribute(a[k]); if (!v || v.indexOf('/cdn/shop/') < 0) continue;
      var nv = swapUrl(v); if (nv !== v) el.setAttribute(a[k], nv);
    }
  }
  function swapImgs(root) { if (!IMG || !root.querySelectorAll) return; if (/^(IMG|SOURCE)$/.test(root.tagName)) swapImg(root); var l = root.querySelectorAll('img,source'); for (var i = 0; i < l.length; i++) swapImg(l[i]) }

  // ---------- run ----------
  function reveal() { document.documentElement.classList.remove('ody-i18n-wait') }
  var mo = new MutationObserver(function (recs) {
    for (var i = 0; i < recs.length; i++) {
      var r = recs[i];
      if (r.type === 'characterData') { if (dict) doText(r.target) }
      else if (r.type === 'attributes') { if (r.attributeName === 'href') fixLink(r.target); else if (/src/.test(r.attributeName)) { if (/^(IMG|SOURCE)$/.test(r.target.tagName)) swapImg(r.target) } else if (dict) doAttrs(r.target) }
      else for (var j = 0; j < r.addedNodes.length; j++) { var n = r.addedNodes[j]; if (n.nodeType === 1) swapImgs(n); if (dict) walk(n); if (n.nodeType === 1) fixLinks(n) }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ATTRS.concat(['href', 'value', 'src', 'srcset', 'data-src', 'data-srcset']) });

  function start() {
    if (document.body) { ui(); fixLinks(document.body); swapImgs(document.body) }
    if (isPrimary) return;
    document.documentElement.setAttribute('lang', LANG);
    if (!dict) return;
    walk(document.body); doHead(); reveal();
  }
  window.odyI18nDict = function (d) {
    dict = Object.assign(dict || {}, d || {}); buildPatterns();
    if (document.body) { walk(document.body); doHead() }
    if (document.readyState !== 'loading') reveal();
  };
  if (window.__odyI18nPending) window.odyI18nDict(window.__odyI18nPending);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  // Never leave the page hidden: show it after 2.5 s even if the dictionary is slow.
  setTimeout(reveal, 2500);
  window.addEventListener('load', function () { if (dict) { walk(document.body); doHead() } reveal() });
})();
